export const useRandomAliasGenerator = () => {
    const generate = () => {
        const alias = Math.random()
                          .toString(36)
                          .substring(2, 10)
        return alias
    }
    return {
        generateRandomAlias: generate
    }
}